import { Form, Select } from "antd";
import { agentsSelector } from "appredux/selectors";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const AgentSelector = ({
  placeholder = "select_agent",
  autocompleteProps,
  name = "agent_id",
  ...props
}) => {
  const { t } = useTranslation();
  const agents = useSelector(agentsSelector);

  return (
    <Form.Item label={t("agent")} name={name} {...props}>
      <Select
        placeholder={t(placeholder)}
        options={agents}
        allowClear
        fieldNames={{ label: "name", value: "id" }}
        showSearch
        filterOption
        optionFilterProp="name"
        {...autocompleteProps}
      />
    </Form.Item>
  );
};

export default AgentSelector;
